import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { produce } from "../../../../../../../libs/immer";
import { isValidEmail } from "./utils";
import { closeScenarioPopupUseCase } from "../../RequestStatus/logic/closePopup.case";
import { submitPaymentUseCase } from "../../../PaymentSelection/components/PaymentMethodSection/Button/logic/submitPaymentCase";
export var submitEmailUseCase = function submitEmailUseCase(_ref) {
  var getContent = _ref.getContent,
    getIsBeelineError = _ref.getIsBeelineError,
    getIsMobile = _ref.getIsMobile,
    getUserAccountInfo = _ref.getUserAccountInfo,
    setUserAccountInfo = _ref.setUserAccountInfo,
    submitPayment = _ref.submitPayment;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(getState, setState) {
      var _state$scenario, _state$scenario2;
      var content, state, _error;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            content = getContent();
            state = getState();
            if (!(((_state$scenario = state.scenario) === null || _state$scenario === void 0 ? void 0 : _state$scenario.type) !== 'email')) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return");
          case 4:
            _error = !isValidEmail(state.scenario.emailInput.value) ? content.emailPopup.emailInput.label : undefined;
            setState(function (prev) {
              return produce(prev, function (draft) {
                var _draft$scenario;
                if (((_draft$scenario = draft.scenario) === null || _draft$scenario === void 0 ? void 0 : _draft$scenario.type) !== 'email') return;
                draft.scenario.emailInput.errorMessage = _error;
              });
            });
            if (!_error) {
              _context.next = 8;
              break;
            }
            return _context.abrupt("return");
          case 8:
            if (!(((_state$scenario2 = state.scenario) === null || _state$scenario2 === void 0 ? void 0 : _state$scenario2.type) !== 'email')) {
              _context.next = 10;
              break;
            }
            return _context.abrupt("return");
          case 10:
            _context.next = 12;
            return setUserAccountInfo({
              email: state.scenario.emailInput.value
            });
          case 12:
            closeScenarioPopupUseCase(setState);
            _context.next = 15;
            return submitPaymentUseCase({
              getContent: getContent,
              submitPayment: submitPayment,
              getIsBeelineError: getIsBeelineError,
              getIsMobile: getIsMobile,
              getUserAccountInfo: getUserAccountInfo
            })(getState, setState);
          case 15:
            _context.next = 17;
            return setUserAccountInfo({
              email: undefined
            });
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};